import './App.css';

const MAINTENANCE_MODE = true;

function MaintenancePage() {
  return (
    <div className="App">
      <nav className="App-nav">
        <img src="/logo.jpeg" className="App-logo" alt="ARISE AI" />
      </nav>
      <main className="App-main maintenance">
        <section>
          <h2>We'll be back soon</h2>
          <p>ARISE AI is currently undergoing maintenance. Please check back later.</p>
        </section>
      </main>
      <footer className="App-footer">
        <p>&copy; 2025 ARISE AI LTD. All rights reserved.</p>
      </footer>
    </div>
  );
}

function App() {
  const smoothScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  if (MAINTENANCE_MODE) {
    return <MaintenancePage />;
  }

  return (
    <div className="App">
      <nav className="App-nav">
        <img src="/logo.jpeg" className="App-logo" alt="logo" />
        <ul>
          <li><a href="#about" onClick={(e) => {e.preventDefault(); smoothScroll('about');}}>About</a></li>
          <li><a href="#services" onClick={(e) => {e.preventDefault(); smoothScroll('services');}}>Services</a></li>
          <li><a href="#contact" onClick={(e) => {e.preventDefault(); smoothScroll('contact');}}>Contact</a></li>
        </ul>
      </nav>
      <main className="App-main">
        <section id="welcome">
          <h2>Welcome to ARISE AI LTD</h2>
          <p>Innovative solutions for a smarter future. We are at the forefront of artificial intelligence, creating technologies that redefine industries and create new opportunities.</p>
          <button className="cta-button" onClick={() => smoothScroll('about')}>Learn More</button>
        </section>
        <section id="about">
          <h3>About Us</h3>
          <p>Founded in 2024, ARISE AI LTD is a team of passionate engineers, researchers, and business experts dedicated to solving complex challenges with artificial intelligence. Our mission is to democratize AI and make its benefits accessible to all. We believe in a future where AI and human ingenuity work together to create a better world.</p>
        </section>
        <section id="services">
          <h3>Our Services</h3>
          <div className="services-container">
            <div className="service-card">
              <div className="service-icon">🤖</div>
              <h4>Custom AI Model Development</h4>
              <p>We design and build bespoke AI models tailored to your specific business needs, from natural language processing to computer vision.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">🧠</div>
              <h4>Machine Learning Consulting</h4>
              <p>Our experts provide guidance and support to help you integrate machine learning into your existing infrastructure and workflows.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">📊</div>
              <h4>Data Analytics and Visualization</h4>
              <p>We help you unlock the power of your data with advanced analytics and intuitive visualizations that provide actionable insights.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">🚀</div>
              <h4>AI-Powered Automation</h4>
              <p>We develop intelligent automation solutions that streamline your business processes, increase efficiency, and reduce costs.</p>
            </div>
          </div>
        </section>
        <section id="contact">
          <h3>Contact Us</h3>
          <p>Whether you have a specific project in mind or just want to learn more about how AI can help your business, we'd love to hear from you.</p>
          <p>Address: 42 York St, Twickenham TW1 3LJ</p>
          <div className="map-container">
            {/* To get the real map URL, go to Google Maps, search for the address, click "Share", then "Embed a map", and copy the src attribute from the iframe. */}
            <iframe 
              title="Google Map of ARISE AI LTD location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2486.582393392471!2d-0.329490384232369!3d51.4473399796253!2m3!1f0!2f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48760b2108889899%3A0xad5f45850a563b95!2s42%20York%20St%2C%20Twickenham%20TW1%203LJ%2C%20UK!5e0!3m2!1sen!2sus!4v1678886400000!5m2!1sen!2sus"
              width="600"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade">
            </iframe>
          </div>
        </section>
      </main>
      <footer className="App-footer">
        <p>&copy; 2025 ARISE AI LTD. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;
